module.exports = __webpack_public_path__ + "img/logoYellow.983054f3.png";